import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { Toaster, ToasterType } from "./toaster.interface";

@Injectable({
  providedIn: "root"
})
export class ToasterService {
  private subject = new Subject<Toaster>();
  toast$: Observable<Toaster> = this.subject.asObservable();

  private clearSubject = new Subject<void>();
  clear$: Observable<void> = this.clearSubject.asObservable();

  constructor() {}

  show(type: ToasterType, title?: string, body?: string, delay?: number) {
    this.subject.next({ type, title, body, delay });
  }

  clear() {
    this.clearSubject.next();
  }
}
